/**
 * AssetThumb — one tile in the library or the picker.
 *
 * Shows the picture itself where there is one, and the plainest possible
 * stand-in where there is not: a sermon recording and a safeguarding policy
 * should not both appear as a grey rectangle.
 */
import React from 'react';
import { FileText, Film, Music, ImageOff } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const absolute = (url) => (url && url.startsWith('/') ? `${API_URL}${url}` : url || '');

export const AssetThumb = ({ asset, className = '' }) => {
  const [broken, setBroken] = React.useState(false);
  React.useEffect(() => setBroken(false), [asset?.preview_url]);

  const base = `flex h-full w-full items-center justify-center ${className}`;

  if (asset?.kind === 'image' && !broken) {
    return (
      <img src={absolute(asset.preview_url || asset.url)} alt={asset.name}
           loading="lazy" onError={() => setBroken(true)}
           className={`h-full w-full object-cover ${className}`} />
    );
  }
  if (asset?.kind === 'video') {
    return <span className={`${base} bg-slate-900 text-slate-400`}><Film className="h-6 w-6" /></span>;
  }
  if (asset?.kind === 'audio') {
    return <span className={`${base} bg-indigo-950 text-indigo-300`}><Music className="h-6 w-6" /></span>;
  }
  if (broken) {
    return <span className={`${base} bg-slate-100 text-slate-400`}><ImageOff className="h-6 w-6" /></span>;
  }
  return <span className={`${base} bg-slate-100 text-slate-500`}><FileText className="h-6 w-6" /></span>;
};

export default AssetThumb;
